import './assets/styles/main.css'
import PrimeVue from 'primevue/config'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { userStore } from '@/stores/userStore.ts'
import { timezoneStore } from '@/stores/timezoneStore'
import ToastService from 'primevue/toastservice'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(PrimeVue)
app.use(VueQueryPlugin)
app.use(ToastService)

const user = userStore()
const timezone = timezoneStore()

const initializeApp = async () => {
  try {
    await user.getCurrentUser()
    timezone.initializeTimezone()
  } finally {
    app.mount('#app')
  }
}

initializeApp()
